// extracted by mini-css-extract-plugin
export default {"wrapper":"_p-z","response":"aq-z","error":"bq-z","disabled":"cq-z","buttons":"dq-z","feedbackQuestionSection":"eq-z","yesNoWrapper":"fq-z"};